import request from '@/utils/request'

export function getMenusTree(params) {
  return request({
    url: 'api/menus/tree',
    method: 'get',
    params
  })
}
export function getMenusByRole(id) {
  return request({
    url: 'api/roles/menus/' + id,
    method: 'get'
  })
}
export function buildMenus() {
  return request({
    url: 'auth/user/menu',
    method: 'get'
  })
}

export function add(data) {
  return request({
    url: 'api/menus',
    method: 'post',
    data
  })
}

export function del(ids) {
  return request({
    url: 'api/menus',
    method: 'delete',
    data: ids
  })
}

export function edit(data) {
  return request({
    url: 'api/menus',
    method: 'put',
    data
  })
}

export default { add, edit, del, getMenusTree, getMenusByRole }
